// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7571":"9d67ac02","8120":"e872979c","8688":"c979e12a"}[chunkId] + ".chunk.css";
};